<template>
  <div>
    <div class="container1">
      <div class="boxMaxWidth" >
        <!-- 政策解读 -->
        <div class="context-box" >
              <div class="context-title">
                  <p> {{ policyList.channel_name }} </p>
                  <el-button type="primary" round @click="handleArtivle">
                     更多+
                  </el-button>
                  <!-- <span>更多+</span> -->
              </div>
              <div class="context-main">
                  <div v-for="item in policyList.items" :key="item.id" @click="getDetailId(item.id,'政策解读')">
                     <div class="flex-box" >
                        <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl" style="margin-left: 15px;"> 
                        <div v-show="item.firstFile.FileUrl" class="contextImg">
                            <img :src="item.firstFile.FileUrl" style="width: 70px;height: 52px; object-fit: cover;" alt="">
                        </div>
                        <div class="titleP">
                             <p>{{ item.title }}</p>
                        </div>
                        
                     </div>
                     
                     
                      <div class="dividerD"></div>
                  </div>
                  
              </div>
        </div>
        <!-- 新闻资讯 -->
        <div class="context-box" >
            <div class="context-title">
                <p> {{ newsList.channel_name }} </p>
                <el-button type="primary" round @click="handleArtivleNews">
                     更多+
                  </el-button>
            </div>
            <div class="context-main">
                <div v-for="item in newsList.items" :key="item.id" @click="getDetailId(item.id,'新闻资讯')">
                    <div class="flex-box" >
                    <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl" style="margin-left: 15px;"> 
                    <div v-show="item.firstFile.FileUrl" class="contextImg" >
                        <img :src="item.firstFile.FileUrl" style="width: 70px;height: 52px; object-fit: cover;" alt=""></div>
                    <div class="titleP">
                            <p>{{ item.title }}</p>
                    </div>
                    
                    </div>
                    
                    
                    <div class="dividerD"></div>
                </div>
                
            </div>
        </div>
        <!-- 企业防灾 -->
        <div class="context-box contMargin" >
            <div class="context-title">
                <p> {{ preventionList.channel_name }} </p>
                <el-button type="primary" round @click="getPrevention">
                     更多+
                  </el-button>
            </div>
            <div class="context-main">
                <div v-for="item in preventionList.items" :key="item.id" @click="getDetailId(item.id,'企业防灾')">
                    <div class="flex-box" >
                    <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl" style="margin-left: 15px;"> 
                    <div v-show="item.firstFile.FileUrl" class="contextImg">
                        <img :src="item.firstFile.FileUrl" style="width: 70px;height: 52px; object-fit: cover;" alt="">
                    </div>
                    <div class="titleP">
                            <p>{{ item.title }}</p>
                    </div>
                    
                    </div>
                    
                    
                    <div class="dividerD"></div>
                </div>
                
            </div>
        </div>
        <!-- 风险案列 -->
        <div class="context-box contMargin" >
            <div class="context-title">
                <p> {{ riskCaseList.channel_name }} </p>
                <el-button type="primary" round @click="getCase">
                     更多+
                  </el-button>
            </div>
            <div class="context-main">
                <div v-for="item in riskCaseList.items" :key="item.id" @click="getDetailId(item.id,'风险案列')">
                    <div class="flex-box" >
                    <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl" style="margin-left: 15px;"> 
                    <div v-show="item.firstFile.FileUrl" class="contextImg">
                        <img :src="item.firstFile.FileUrl" style="width: 70px;height: 52px; object-fit: cover;" alt="">
                    </div>
                    <div class="titleP">
                            <p>{{ item.title }}</p>
                    </div>
                    
                    </div>
                    
                    
                    <div class="dividerD"></div>
                </div>
                
            </div>
        </div>
      </div>
    
      <div class="advertisement" v-if="widthNew">
          <div v-for="item in carouselList" :key="item.id" :style="'background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;width: 100%;height:100%'"></div>
          <!-- <div></div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default{
    data(){
        return{
            riskCaseList:{},
            newsList: {},
            policyList: {},
            preventionList: {},
            widthNew: false,
            carouselList: []
        }
    },
    methods: {
        getListArticle(data){
            this.$store.dispatch('login/listarticle',data)
                .then(res => {
                    if(res.ok){
                        if(data.channel == 'case'){
                            this.riskCaseList = res.data
                        }else if(data.channel == 'news'){
                            this.newsList = res.data
                        }else if(data.channel == 'policy'){
                            this.policyList = res.data
                        }else if(data.channel == 'prevention'){
                            this.preventionList = res.data
                        }
                    }
                })
        },
        getDetailId(id,name){


            const { href } = this.$router.resolve({
                path: '/detailPages',
                query: {
                    key: id,
                    currentName: name
                }
            });
            window.open(href, '_blank');

        },
        handleArtivle(){
            this.$router.push({
                path: '/article',
            })
            sessionStorage.setItem("name",'政策解读') 
            sessionStorage.setItem("channel",'policy') 
            sessionStorage.setItem("typeId","")
        },
        handleArtivleNews(){
            this.$router.push({
                path: '/article',
            })
            sessionStorage.setItem("name",'新闻中心') 
            sessionStorage.setItem("channel",'news') 
            sessionStorage.setItem("typeId","")
        },
        getPrevention(){
            this.$router.push({
                path: '/article',
            })
            sessionStorage.setItem("name",'企业防灾') 
            sessionStorage.setItem("channel",'prevention') 
            sessionStorage.setItem("typeId","")
        },
        getCase(){
            this.$router.push({
                path: '/article',
            })
            sessionStorage.setItem("name",'风险案列') 
            sessionStorage.setItem("channel",'case') 
            sessionStorage.setItem("typeId","")
        },
        getImgList(){
             let data = {
                cate_value: "homepcvertical"
            }
            this.$store.dispatch('login/listads',data)
                .then(res => {
                    this.carouselList = res.data.items
                })
        }
    },
    mounted(){
        this.getImgList()
        // 风险案列
        let data = {
            channel: 'case',
            pageNum: 1,
            pageSize: 5
        }
        this.getListArticle(data)

        // 新闻资讯
        let news = {
            channel: 'news',
            pageNum: 1,
            pageSize: 5
        }
        this.getListArticle(news)
        
        // 政策解读
        let policy = {
            channel: 'policy',
            pageNum: 1,
            pageSize: 5
        }
        this.getListArticle(policy)

        // 企业防灾
        let prevention = {
            channel: 'prevention',
            pageNum: 1,
            pageSize: 5
        }
        this.getListArticle(prevention)
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
    }
}
</script>
<style scoped>

.boxMaxWidth{
    height: 100%;width: 78%;
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    padding: 10px 10px;
    background: #fff;
}
.context-title{
    height: 50px;width: 100%;
    margin-bottom: 5px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border-bottom: 0.5px solid #f2f2f2;
}
.context-title p{
    width: 200px;
    font-size: 22px;
    font-weight: 700;
    /* background: rgb(187, 208, 247); */
    /* background: rgb(209, 223, 250,0.4); */
    border-radius: 100px;
    padding: 10px 0 10px 15px;
}
/* .context-title span{
    color: #5087EC;
    cursor: pointer;
    font-size: 16px;
} */

.context-main{
    width: 98%;
    padding: 10px 5px 0 5px;
    /* background: rgb(209, 223, 250,0.4); */
    cursor: pointer;
}
.flex-box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /* border-bottom: 1px solid #cfd9e2; */
    font-size: 17px;
    margin-top: 4px;
}
.flex-box img{
    width: 52px;height: 52px;

}
.contextImg{
    width: 80px;

    
}
.flex-box p{
    /* width: 75%; */
    /* margin-left: 10px; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.titleP{
    width: 390px;height: 52px;
    margin-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 52px;
    
}
.titleP:hover{
    font-weight: 600;
}
.dividerD{
    width: 100%;
    border-bottom: 0.5px solid #f2f2f2;
    margin: 10px 0;
}

.advertisement{
    width: 18%;height: 960px;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 0 10px;
    
    /* background: rgb(186, 207, 247); */
}
.advertisement div{
    flex-grow: 1;
    width: 100%;height: 130px;
    display: flex;
    margin: 10px 0;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.advertisement div:nth-child(1){  
    background-image:url('../../assets/da5a55fa916e4c769369f3a58d68491a.jpg');
}
.advertisement div:nth-child(2){  
    background-image:url('../../assets/31bb7bb4-26c4-4542-881d-a38b1b388ab4.jpg');
}
.contMargin{
    margin-top: 10px;
}
@media screen and (min-width: 541px) {
    .container1{
        width: 1200px;
        display: flex;
        justify-content: space-between;
        /* height: 650px; */
        margin-top: 20px;
    
    }
    .context-box{
        width: 49%;
    }
}
@media screen and (max-width: 540px) {
    .container1{
        width: 100%;
        margin: 20px auto;
    
    }
    .boxMaxWidth{
        width: 100%;
        padding: 0 0;
    }
    .context-box{
        width: 99%;
    }
    .context-title{
        height: 50px;width: 100%;
        margin-bottom: 5px;
        padding-bottom: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        border-bottom: 0.5px solid #f2f2f2;
    }
    .context-title p{
        width: 200px;
        font-size: 18px;
        font-weight: 700;
        /* background: rgb(187, 208, 247); */
        /* background: rgb(209, 223, 250,0.4); */
        border-radius: 100px;
        padding: 10px 0 10px 5px;
    }
    .titleP{
        font-size: 14px;
    }

}
</style>